<template lang="pug">
  .template-modal.text-xs-center
    v-dialog(
      v-model="isOpen"
      persistent
      :width="width"
    )
      v-card
        v-card-title.title-bar(
          v-if="header"
          primary-titleeE
        )
          v-layout(
            align-center
            justify-center
            row
            fill-height
          )
            displays-text(
              :text="header"
              type="headline"
              color="grey"
              no-truncate
            )
        v-card-text.py-0
          slot(
            name="content"
          )
        v-divider(v-if="!removeDivider")
        v-card-actions.py-2
          slot(name="actions")
</template>

<script>
import DisplaysText from '../DisplaysText.vue';

export default {
  name: 'TemplateModal',
  components: {
    DisplaysText,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    removeDivider: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: '650',
    },
    header: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="stylus">
  .action-bar
    padding 32px !important
    background #FAF9FA
  .title-bar
    background #FAF9FA
  .page-title
    color #35363B
    font-weight 500
    font-size 24px
    line-height 28px
</style>
